import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { MergeRequest } from '@portal-core/merge-requests/models/merge-request.model';

@CollectionStateSelectors({
  stateType: MergeRequestsState
})
@State<MergeRequestsState>({
  name: MergeRequestsState.source,
})
@Service({ autoProvided: false })
export class MergeRequestsState extends CollectionStateBase {
  static override source: string = 'MergeRequests';
  getSource(): string {
    return MergeRequestsState.source;
  }
}

@Service()
export class MergeRequestsDataService extends CollectionDataServiceBase<MergeRequest> {
  protected readonly stateType = MergeRequestsState;
}
